import { BaseError } from '@nsftx/seven-client-retail-utils'
import type { DMAcceptorsErrorType } from '#src/types/DMAcceptorsErrorTypes'

export default class DMAcceptorsError extends BaseError<DMAcceptorsErrorType> {
  constructor(
    public message: string,
    public code: DMAcceptorsErrorType,
    public options?: {
      cause?: unknown
      context?: unknown
    }
  ) {
    super(message, code, options)
    Object.setPrototypeOf(this, DMAcceptorsError.prototype)
    this.name = this.constructor.name
  }
}
